var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.844,
    height: 20.095,
    viewBox: "0 0 38.844 20.095",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8569",
    "data-name": "Group 8569",
    transform: "translate(-1263.81 -109.117)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10847",
    "data-name": "Path 10847",
    d: "M1301.711,128.926l.043-.011.036-.009c.014,0,.028-.01.041-.015l.037-.013.037-.017c.012-.006.025-.011.037-.018l.035-.02c.012-.008.024-.014.035-.022s.024-.018.036-.026l.03-.023c.018-.015.035-.031.052-.047l.009-.008.009-.01.047-.051.024-.033c.008-.011.017-.022.024-.033a.393.393,0,0,0,.023-.038.276.276,0,0,0,.019-.032c.007-.013.013-.026.019-.04l.017-.035c.005-.012.009-.025.014-.038l.013-.039c0-.013.007-.026.01-.04a.286.286,0,0,0,.01-.039c0-.016.005-.032.007-.047l.005-.034a.756.756,0,0,0,0-.083V110.224a.837.837,0,0,0-.836-.837H1275.2l-.022,0-.048,0-.037,0-.043.007-.04.008-.039.01-.039.012-.039.014-.036.015-.039.019-.032.018-.039.023-.03.021-.035.026-.031.026-.03.027-.032.032-.016.017-.008.01c-.011.012-.02.025-.03.038l-.021.028c-.009.012-.017.025-.025.038l-.02.032-.019.038-.017.036a.4.4,0,0,0-.015.038l-.014.038-.011.039-.01.04-.007.038-.007.044,0,.036c0,.016,0,.031,0,.047v5.173a.836.836,0,0,0,1.673,0v-3.3l7.438,6.585a.748.748,0,0,0-.111.092l-7.327,7.327v-5.5a.836.836,0,1,0-1.673,0v1.022h-4.322a.836.836,0,1,0,0,1.673h4.322V128.1a.837.837,0,0,0,.836.837h26.352c.027,0,.055,0,.082,0l.038-.006Zm-1-2.84-7.327-7.327-.014-.013,5.508-4.673a.837.837,0,0,0-1.082-1.276l-9.412,7.985-10.981-9.721h23.308v15.025Zm-16.168-6.144a.81.81,0,0,0,.146-.2l3.129,2.77a.834.834,0,0,0,1.095.012l3.189-2.705a.852.852,0,0,0,.1.12l7.327,7.327h-22.312Z",
    fill: "#6c5b7b",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.54
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10848",
    "data-name": "Path 10848",
    d: "M1264.647,118.915h14.128a.837.837,0,1,0,0-1.673h-14.128a.837.837,0,1,0,0,1.673Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10849",
    "data-name": "Path 10849",
    d: "M1266.111,114.305h6.343a.836.836,0,1,0,0-1.673h-6.343a.836.836,0,1,0,0,1.673Z",
    fill: "#6c5b7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10850",
    "data-name": "Path 10850",
    d: "M1270.781,125.142h-6.134a.837.837,0,1,0,0,1.673h6.134a.837.837,0,1,0,0-1.673Z",
    fill: "#6c5b7b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceMsg);
export default __webpack_public_path__ + "static/media/invoice-msg.1284604ca4842f5700465613baa6e292.svg";
export { ForwardRef as ReactComponent };